<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <g clip-path="url(#clip0_3313_54197)">
            <path
                d="M10.6293 8.02831C10.987 7.73304 11.3442 7.43738 11.7026 7.14272C11.8773 6.99898 12.108 6.75749 12.2969 6.64175C12.4423 6.55279 12.5779 6.62715 12.5391 6.76949L11.1309 9.1394C11.085 9.21656 11.0405 9.33531 11.21 9.33371H15.5296C15.5641 7.22028 14.2478 5.61682 12.1506 5.07327C8.7905 4.20227 3.79976 5.29197 4.38658 9.52562C4.65226 11.4431 6.08118 12.1858 7.67856 12.7034L9.74062 10.4786C9.82682 10.3856 9.75765 10.2523 9.62097 10.2473L8.33663 10.2017C8.23131 10.1871 8.17689 10.0908 8.23817 10.0114C9.02834 9.3519 9.82163 8.695 10.6158 8.0389"
                fill="currentColor"
            />
            <path
                d="M9.12555 14.8738C8.74958 15.1662 8.3736 15.4589 7.997 15.7508C7.81732 15.8899 7.57823 16.1256 7.38526 16.2363C7.23694 16.3215 7.10421 16.2437 7.14825 16.1022L8.64073 13.7681C8.66836 13.7247 8.71821 13.6385 8.64675 13.6391H4.16743C4.1182 16.2257 6.03215 17.8426 8.56637 18.2144C11.8507 18.6962 16.0707 17.8066 15.8227 13.8302C15.6779 11.5091 13.9825 10.7513 12.1078 10.2053L10.1307 12.4755C10.0507 12.5672 10.1168 12.6948 10.2485 12.7028L11.4697 12.7783C11.5744 12.7957 11.6253 12.8937 11.5611 12.9712C10.757 13.6033 9.95 14.2327 9.14196 14.8612"
                fill="currentColor"
            />
            <path
                d="M9.99986 3.93339C11.1285 3.93339 12.0434 3.05287 12.0434 1.9667C12.0434 0.88052 11.1285 0 9.99986 0C8.87122 0 7.95629 0.88052 7.95629 1.9667C7.95629 3.05287 8.87122 3.93339 9.99986 3.93339Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_3313_54197">
                <rect width="20" height="20" fill="currentColor" />
            </clipPath>
        </defs>
    </svg>
</template>
